export default "__VITE_ASSET__Bgu4KTlD__"